import { DownloadState } from '@repo/core'
import { RootState } from '../../../store/types'

export const bankingProductLoanReceiptsDownloadSelectorConfig = {
  bankingProductLoanReceiptsDownloadSelector: {
    getRootPath: (state: RootState): DownloadState =>
      state.accounts.master.list.bankingProductLoanReceiptsDownload,
  },
}
